import { FormHelperText } from "@mui/material"
import React from "react"

import { ValidationType } from "@features/builder/graph/nodes/validation/types"
import { useNodesValidation } from "@features/builder/graph/nodes/validation/useNodesValidation"

interface ValidatedMnemonicFieldProps extends React.PropsWithChildren {
  nodeId: string
  errorsKey: ValidationType
}

const ValidatedMnemonicField = (props: ValidatedMnemonicFieldProps) => {
  const { getNodeValidation } = useNodesValidation()

  const errors = [getNodeValidation(props.nodeId, props.errorsKey)?.errors].flatMap(
    (error) => error ?? [],
  )

  return (
    <>
      {props.children}
      {errors.map((error, index) => (
        <FormHelperText key={index} error>
          - {error.msg}
        </FormHelperText>
      ))}
    </>
  )
}

export default ValidatedMnemonicField
